import { useSelectedCollection } from '../../Collection/hooks/useSelectedCollectionSelectors';
import { useSaveCollectionOverrides } from './useSaveCollectionOverrides';
import { CollectionMetadata } from '../types';
import { useUserId } from '@features/authentication';

export const useSaveSelectedCollectionOverrides = () => {
    const { selectedCollection } = useSelectedCollection();
    const userId = useUserId();

    const { execute: baseExecute, ...mutationState } =
        useSaveCollectionOverrides();

    const isReady = !!selectedCollection?.proscopeId && !!userId;

    const execute = async (overrides: Partial<CollectionMetadata>) => {
        if (!isReady || !selectedCollection) {
            throw new Error('Cannot save overrides: Missing required context.');
        }

        return baseExecute({
            proscopeId: selectedCollection.proscopeId,
            collectionId: selectedCollection.id,
            userId,
            overrides,
        });
    };

    return { execute, isReady, ...mutationState };
};
